import { request } from '../util/request';

const NEWS_API_BASE = process.env.VUE_APP_NEWS_API_BASE || 'http://192.168.56.109:9016'

/**
 * 新闻分页查询
 * POST /server/app/news/page
 */
export async function newsPage(params) {
  const res = await request({
    url: `${NEWS_API_BASE}/server/app/news/page`,
    method: 'post',
    data: params,
  });
  const data = res && res.data ? res.data : res;
  return data;
}

/**
 * 新闻详情查询
 * POST /server/app/news/info
 */
export async function newsInfo(params) {
  const res = await request({
    url: `${NEWS_API_BASE}/server/app/news/info`,
    method: 'post',
    data: params,
  });
  const data = res && res.data ? res.data : res;
  return data;
}

export default {
  newsPage,
  newsInfo,
};